<template>
  <!-- page-title -->
        <div class="ttm-page-title-row">
            <div class="container">
                <div class="row">
                    <div class="col-md-12"> 
                        <slot></slot>
                    </div><!-- /.col-md-12 -->  
                </div><!-- /.row -->  
            </div><!-- /.container -->                      
        </div><!-- page-title end-->
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {}
};
</script>


<style scoped>

</style>



    